import { Component, OnInit, Input } from '@angular/core';
import { SongsService } from '../../api/';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import { MdDialog, MdDialogRef } from '@angular/material';
import { DownloadDetailComponent } from './download-detail/download-detail.component';
import { QuotaExceedComponent } from '../../player/services/player.service';
import { CartService } from '../../api/services/cart.service';
import { MessagesServices } from '../../api/';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
@Component({
  selector: 'download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.css']
})
export class DownloadComponent implements OnInit {
  @Input() item: any;
  @Input() aboveTooltip: string = 'below';
  @Input() isDownloadProcessed: boolean = false;
  private downloadDetailRef: MdDialogRef<DownloadDetailComponent>;
  public downloading = false;
  dialogRef: MdDialogRef<any>;
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
  msg2: any = '';
  title2: any = '';
  msg3: any = '';
  title3: any = '';
  msg4: any = '';
  title4: any = '';
  msg5: any = '';
  title5: any = '';
  msg6: any = '';
  title6: any = '';
    @BlockUI() blockUI: NgBlockUI;
  public onlineOffline1: boolean = navigator.onLine;

  constructor(private songsService: SongsService, private sm: MessagesServices, private cartService: CartService, private toastyService: ToastyService, public dialog: MdDialog) {
    window.addEventListener('online', () => {this.onlineOffline1 = true; });
    window.addEventListener('offline', () => {this.onlineOffline1 = false});

    this.messages = this.sm.messags;
    this.setMessages();
  }

  ngOnInit() {
  }

  /**
  * setting system messages 
  * TODO delete
  **/
  myFunction() {
    for (var i = 0; i < this.messages.length; i++) {
      if (this.messages[i].event == 'WG_EVENT_DOWNLOAD_LIMIT_EXCEEDED') {
        this.title5 = this.messages[i].title;
        this.msg5 = this.messages[i].message;
      }
    }
  }
  setMessages() {
    if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_ADDED_TO_DOWNLOADS') {
          this.title1 = this.messages[i].title;
          this.msg1 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_UNABLE_TO_DOWNLOAD_FILE') {
          this.title2 = this.messages[i].title;
          this.msg2 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_ALREADY_ADDED_TO_DOWNLOADS') {
          this.title3 = this.messages[i].title;
          this.msg3 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_CANNOT_ADD_TO_DOWNLOADS') {
          this.title4 = this.messages[i].title;
          this.msg4 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_SONG_DOWNLOAD_QUOTA_EXCEEDED_FOR_LOGGED_IN_USER') {
          this.title5 = this.messages[i].title;
          this.msg5 = this.messages[i].message;
        }
      }

    }
  }
  download(event) {

    event.stopPropagation();
    event.preventDefault();
    // will be called initially
    if (this.isDownloadProcessed === false) {
      if (this.onlineOffline1) {
        this.blockUI.start('Loading, please wait...');
        this.songsService.addToMyDownloads(this.item.id).subscribe((res) => {
          let toastOptions: ToastOptions = {
            title: this.title3,
            msg: this.msg3,
            showClose: true,
            timeout: 2000,
            theme: 'default'
          }; // alert(res.msg);
          if (res.code === 'ok') {
            this.blockUI.stop();
            this.toastyService.success(toastOptions);
          } else if (res.code === 'error') {
            this.blockUI.stop();
            this.toastyService.error(toastOptions);
          }
        }, (err) => {
          // let error = err.json();
          let toastOptions: ToastOptions = {
            title: this.title4,
            msg: this.msg4,
            showClose: true,
            timeout: 2000,
            theme: 'default'
          };
          // alert(error.message);
          if (this.msg5 != "" && this.title5 != "") {
            this.dialogRef = this.dialog.open(QuotaExceedComponent, {width: '650px'});
            this.dialogRef.componentInstance.message = this.msg5;
            this.dialogRef.componentInstance.title = this.title5;
            this.dialogRef.componentInstance.navigateTo = {title: "Subscribe new package", route: '/my-packages'};
            this.dialogRef.afterClosed().subscribe(result => {
              this.dialogRef = null;
            });
          }
          this.onAddToCart(this.item, event);
          this.blockUI.stop();
          this.toastyService.error(toastOptions);
        });
      }
    }else {    // will be called from my downloads
      if(this.onlineOffline1){
      this.songsService.prepareDownload(this.item.id).subscribe((res) => {
        if (res.code === 'ok') {
          this.downloading = true;
          this.songsService.downloadMp3(res.data.slug).subscribe((downloaded) => {
            this.toastyService.success({
              title: ((downloaded) ? this.title1 : this.title2),
              msg: ((downloaded) ? this.msg1 : this.msg2),
              showClose: true,
              timeout: 2000,
              theme: 'default'
            });
            this.downloading = false;
          });
        }
      });
    }
    }
  }

  info(event, downloadObj) {
    this.downloadDetailRef = this.dialog.open(DownloadDetailComponent, { width: '650px' });
    this.downloadDetailRef.componentInstance.downloadDetail = downloadObj;
  }
  onAddToCart(item,event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.onlineOffline1){
    this.cartService.addItem(item);
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/download/download.component.ts